// Navigation data for Nav component

import {
  BookmarkFilled,
  Calendar,
  Dashboard,
  Events,
  Group,
  Task,
  WorkflowAutomation,
} from "@carbon/icons-react";

export interface QuickAction {
  url: string;
  icon: React.ComponentType<any>;
  label: string;
  color: string;
}

export interface NavLink {
  url: string;
  icon: React.ComponentType<any>;
  label: string;
  badge?: string;
}

export interface IndustryGroup {
  url: string;
  name: string;
  emoji: string;
  memberCount: string;
  trending?: boolean;
}

// Quick Actions
export const quickActions: QuickAction[] = [
  {
    url: "/jobs/post",
    icon: Task,
    label: "Đăng việc làm",
    color: "bg-green-500 hover:bg-green-600",
  },
  {
    url: "/events/create",
    icon: Calendar,
    label: "Tạo sự kiện",
    color: "bg-purple-500 hover:bg-purple-600",
  },
];

// My Groups Links
export const myGroupsLinks: NavLink[] = [
  {
    url: "/group",
    icon: Group,
    label: "Nhóm của tôi",
    badge: "8",
  },
  {
    url: "/group?roleFilter=MANAGER",
    icon: WorkflowAutomation,
    label: "Quản lý nhóm",
    badge: "2",
  },
  {
    url: "/group",
    icon: WorkflowAutomation,
    label: "Thống kê nhóm",
  },
];

// Personal Links
export const personalLinks: NavLink[] = [
  {
    url: "/my-profile",
    icon: Dashboard,
    label: "Hồ sơ của tôi",
  },
  {
    url: "/my-posts",
    icon: Task,
    label: "Bài viết của tôi",
  },
  {
    url: "/saved",
    icon: BookmarkFilled,
    label: "Đã lưu",
  },
  {
    url: "/events",
    icon: Events,
    label: "Sự kiện",
  },
];

// Industry Groups
export const industryGroups: IndustryGroup[] = [
  {
    url: "/groups/tech",
    name: "Công nghệ",
    emoji: "💻",
    memberCount: "28.3k",
    trending: true,
  },
  {
    url: "/groups/design",
    name: "Thiết kế",
    emoji: "🎨",
    memberCount: "15.4k",
  },
  {
    url: "/groups/marketing",
    name: "Marketing",
    emoji: "📱",
    memberCount: "12.7k",
  },
  {
    url: "/groups/healthcare",
    name: "Y tế",
    emoji: "🏥",
    memberCount: "8.9k",
  },
  {
    url: "/groups/education",
    name: "Giáo dục",
    emoji: "📚",
    memberCount: "6.2k",
  },
  {
    url: "/groups/agriculture",
    name: "Nông nghiệp",
    emoji: "🌱",
    memberCount: "4.8k",
  },
];
